import { Box, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    padding: spacing(1, 1, 1, 2),
    gap: '10px'
  },
  checkbox: {
    borderRadius: 4,
    minWidth: 20,
    width: 20,
    height: 20
  },
  label: {
    borderRadius: 4,
    width: '100%',
    height: 20
  }
}));

export const Loader = () => {
  const classes = useStyles();
  return (
    <Box>
      {Array(5)
        .fill(null)
        .map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Box key={index} className={classes.container}>
            <Skeleton variant="rect" className={classes.checkbox} />
            <Skeleton variant="rect" className={classes.label} />
          </Box>
        ))}
    </Box>
  );
};
